<template>
  <div class="home-page">
    <div class="basic-info flex">
      <div class="basic flex align-center column">
        <div class="logo">
          <img :src="require('@/assets/my/avator.png')" alt="" />
        </div>
        <div v-if="userInfo.userInfoVO" class="name">{{ userInfo.userInfoVO.name }}</div>
        <div v-if="userInfo.enterpriseVO" class="company">{{ userInfo.enterpriseVO.company.name }}</div>
        <div v-if="userInfo.userInfoVO" class="company text">
          <img :src="require('@/assets/my/user.png')" alt="" />
          {{ userInfo.userInfoVO.roleName }}
        </div>
        <div v-if="userInfo.userInfoVO" class="company text">
          <img :src="require('@/assets/my/phone.png')" alt="" />
          {{ userInfo.userInfoVO.mobile }}
        </div>
      </div>
      <div class="block"></div>
      <div class="address">
        <div class="title">收货信息</div>
        <div class="item">
          <span class="label">药店名称：</span>
          <span v-if="userInfo.enterpriseVO && userInfo.enterpriseVO.stores" class="value">
            {{ userInfo.enterpriseVO.stores[0].name }}
          </span>
        </div>
        <div class="item">
          <span class="label">收货地址：</span>
          <span class="value">{{ addressInfo.merchantAddr }}</span>
        </div>
      </div>
    </div>
    <div class="order-info">
      <div class="title">我的订单</div>
      <div class="card">
        <div class="tab flex column align-center">
          <div @click="goOrder('')" class="pointer icon">
            <img :src="require('@/assets/my/order_all.png')" alt="" />
          </div>
          <div @click="goOrder('')" class="pointer txt">全部</div>
        </div>
        <div class="tab flex column align-center">
          <div @click="goOrder(1)" class="pointer icon">
            <img :src="require('@/assets/my/order_2.png')" alt="" />
          </div>
          <div @click="goOrder(1)" class="pointer txt">待支付</div>
        </div>
        <div class="tab flex column align-center">
          <div @click="goOrder(6)" class="pointer icon">
            <img :src="require('@/assets/my/order_3.png')" alt="" />
          </div>
          <div @click="goOrder(6)" class="pointer txt">待开户</div>
        </div>
        <div class="tab flex column align-center">
          <div @click="goOrder(2)" class="pointer icon">
            <img :src="require('@/assets/my/order_4.png')" alt="" />
          </div>
          <div @click="goOrder(2)" class="pointer txt">待配送</div>
        </div>
        <div class="tab flex column align-center">
          <div @click="goOrder(3)" class="pointer icon">
            <img :src="require('@/assets/my/order_5.png')" alt="" />
          </div>
          <div @click="goOrder(3)" class="pointer txt">配送中</div>
        </div>
      </div>
    </div>
    <!-- <div class="treasure-info">
      <div class="title">我的财富</div>
      <div class="card">
        <div class="item">
          <div class="coupon-box flex align-center">
            <div class="left">
              <div class="number">12张</div>
              <div class="text">我的优惠券</div>
            </div>
            <div class="right pointer">查看</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import * as api from '@/services';
export default {
  data() {
    return {
      addressInfo: {}
    };
  },
  async mounted() {
    this.getBaseInfo();
  },
  computed: {
    ...mapState('USER', {
      userInfo: state => state.userInfo
    })
  },
  methods: {
    async getBaseInfo() {
      const res = await api.personal.getReceiveAddr();
      this.addressInfo = res;
    },
    goOrder(status) {
      this.$router.push(`/orderList?orderStatus=${status}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.home-page {
  width: 100%;
  .basic-info {
    background-color: #ffffff;
    margin-bottom: 17px;
    height: 226px;
    .block {
      width: 16px;
      background-color: #fafafa;
    }
    .basic {
      width: 200px;
      padding-bottom: 16px;
      .logo {
        margin-top: 24px;
        width: 72px;
        height: 72px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 72px;
          height: 72px;
        }
      }
      .name {
        font-size: 16px;
        margin-top: 14px;
      }
      .company {
        font-size: 12px;
        font-weight: 400;
        color: #595959;
        line-height: 12px;
        text-align: center;
        width: 200px;
        padding-left: 16px;
        margin-top: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.text {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        img {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }
      }
    }
    .address {
      width: 100%;
      .title {
        padding-left: 16px;
        height: 42px;
        border-bottom: 1px solid #eeeeee;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        line-height: 42px;
        margin-bottom: 62px;
      }
      .item {
        padding-left: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 18px;
        margin-top: 24px;
        .label {
          min-width: 90px;
        }
      }
    }
  }
}
.order-info {
  background: #ffffff;
  height: 306px;
  .title {
    padding-left: 16px;
    height: 42px;
    border-bottom: 1px solid #eeeeee;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .card {
    padding-top: 24px;
    height: 264px;
    display: flex;
    align-items: center;
    .tab {
      flex-basis: 20%;
      text-align: center;
      img {
        width: 36px;
        height: 36px;
      }
      .txt {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
        text-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
        margin-top: 8px;
      }
    }
  }
}
.treasure-info {
  background: #ffffff;
  height: 266px;
  .title {
    padding-left: 16px;
    height: 42px;
    border-bottom: 1px solid #eeeeee;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .item {
    width: 50%;
    .coupon-box {
      width: 327px;
      height: 128px;
      margin: 30px 0 0 90px;
      padding: 38px 0 0 62px;
      .left {
        margin-right: 60px;
        .number {
          font-size: 24px;
          font-weight: 500;
          color: #ff4e46;
          line-height: 24px;
          margin-bottom: 16px;
        }
        .text {
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          line-height: 12px;
        }
      }
      .right {
        width: 92px;
        height: 28px;
        border: 1px solid #dedede;
        font-size: 12px;
        font-weight: 400;
        color: #555555;
        text-align: center;
        line-height: 28px;
      }
    }
  }
}
</style>
